import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    public loading = signal<boolean>(false);

    public show() {
        this.loading.set(true);
    }

    public hide() {
        this.loading.set(false);
    }
}